module.exports = __webpack_public_path__ + "static/img/logo2.19a4ac21.png";